import React, { useState, useMemo, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import DataTable from '../components/DataTable';
import {
  fetchUsers, fetchAddresses, fetchAlerts, fetchArticles,
  fetchAuthors, fetchCompanies, fetchCompanyAddresses,
  fetchConfigurations, fetchKeywords, fetchPermissions,
  fetchRolePermission, fetchRoles, fetchSources,
  fetchUserAddress, fetchUserAlert, fetchUserRole,
} from '../api/apiClient';
import '../styles/dashboard.css';

const Dashboard = () => {
  const [activeEndpoint, setActiveEndpoint] = useState('users');
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const endpoints = useMemo(() => [
    { id: 'users', name: 'Users', fetchFn: fetchUsers },
    { id: 'addresses', name: 'Addresses', fetchFn: fetchAddresses },
    { id: 'alerts', name: 'Alerts', fetchFn: fetchAlerts },
    { id: 'articles', name: 'Articles', fetchFn: fetchArticles },
    { id: 'authors', name: 'Authors', fetchFn: fetchAuthors },
    { id: 'companies', name: 'Companies', fetchFn: fetchCompanies },
    { id: 'company_addresses', name: 'Company Addresses', fetchFn: fetchCompanyAddresses },
    { id: 'configurations', name: 'Configurations', fetchFn: fetchConfigurations },
    { id: 'keywords', name: 'Keywords', fetchFn: fetchKeywords },
    { id: 'permissions', name: 'Permissions', fetchFn: fetchPermissions },
    { id: 'role_permissions', name: 'Role Permissions', fetchFn: fetchRolePermission },
    { id: 'roles', name: 'Roles', fetchFn: fetchRoles },
    { id: 'sources', name: 'Sources', fetchFn: fetchSources },
    { id: 'user_addresses', name: 'User Addresses', fetchFn: fetchUserAddress },
    { id: 'user_alert', name: 'User Alerts', fetchFn: fetchUserAlert },
    { id: 'user_roles', name: 'User Roles', fetchFn: fetchUserRole },
  ], []);

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      try {
        const endpoint = endpoints.find((e) => e.id === activeEndpoint);
        if (endpoint) {
          const response = await endpoint.fetchFn();
          setData(response.data);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        setData([]);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, [activeEndpoint, endpoints]);

  const activeLabel = endpoints.find((e) => e.id === activeEndpoint)?.name;

  return (
    <div className="dashboard">
      <Sidebar endpoints={endpoints} activeEndpoint={activeEndpoint} onSelect={setActiveEndpoint} />
      <div className="dashboard__main">
        <div className="dashboard__header">
          <h2 className="dashboard__title">{activeLabel}</h2>
          <span className="dashboard__breadcrumb">Dashboard / {activeLabel}</span>
        </div>
        <div className="dashboard__body">
          {loading ? (
            <div className="dashboard__loading">
              <div className="dashboard__spinner" />
              <p>Loading {activeLabel}…</p>
            </div>
          ) : (
            <DataTable data={data} endpoint={activeEndpoint} />
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
